import React, { useState, useEffect } from "react";
import { fetch, fetchLocalAgent } from "../../actions";
import { connect } from "react-redux";
import { LabelPadrao, LoadingContainerPadrao, ModalPadrao } from "../../components/Base";
import Pagamento, { ValoresExtrasPagamento } from "../Pagamento/Pagamento";
import { BtnCancelar, BtnPadrao, BtnSair } from "../../components/Buttons";
import useTotais from "../../components/Hooks/useTotais";
import useSavePagamentos from "../../components/Hooks/useSavePagamentos";
import ErroModal from "../../components/ErroModal";
import ModalQrCode from "../../components/ModalQrCode";
import { formatarPagamentos } from "../../Utils/utils";
import roundCustom from "../../Utils/RoundCustom";
import { Radio } from "antd";
import { imprimirRetorno } from "../../Utils/impressaoUtils";
import DanfeViewer from "../Venda/NotaFiscal/DanfeViewer";
import ImpressaoVenda from "../Impressao/ImpressaoVenda";
import ImpressaoVendaOpcional from "../Impressao/ImpressaoVendaOpcional";
import Mensagens from "../../components/Mensagens";

const INITIAL_VALORES_EXTRAS = { acrescimo: 0, acrescimoPerc: 0, descontoVenda: 0, descontoVendaPerc: 0 };

function Finalizar({ onCancel, onOk, venda, visible, tabIndex, ...props }) {
  const [pg, setPg] = useState([]);
  const [modeloNF, setModeloNF] = useState(null);
  const [valoresExtras, setValoresExtras] = useState(INITIAL_VALORES_EXTRAS);
  const [liquidoInicial, setLiquidoInicial] = useState(0);
  const totais = useTotais(venda?.itensVenda, pg, valoresExtras);
  const [erroFinalizacao, setErroFinalizacao] = useState();
  const [dadosDanfe, setDadosDanfe] = useState(null);
  const [dadosImpressaoOpcional, setDadosImpressaoOpcional] = useState(null);
  const [vendaImpressaoDados, setVendaImpressaoDados] = useState(null);

  const parametros = props?.parametros || {};

  const isOrcamento = venda?.isOrcamento;

  const [salvar, salvando, processandoPagamentos, abortar, abortando, linkQrCode] = useSavePagamentos(isOrcamento ? "/prevenda/orcamento/inserir" : "/venda/inserir", { ...venda, modeloNF, pagamentos: formatarPagamentos(pg, totais.troco), valorTotal: totais.liquido, descontoProduto: totais.desconto, troco: totais.troco, ...totais, ...valoresExtras }
    , v => {

      if (!!v.vendaImpressaoNaoObrigatoriaId) {
        setDadosImpressaoOpcional(v);
        onOk(false);
      }
      else {
        if (v.isDanfe)
          setDadosDanfe(v);
        else if (!!v.vendaId)
          setVendaImpressaoDados(v);
        else
          imprimirRetorno(props.fetchLocalAgent, v);

        onOk(true);
      }

      Mensagens.showSucesso(isOrcamento ? "Orçamento finalizado com sucesso!" : "Venda finalizada com sucesso!");

    }
    , props.fetch
    , erroPagamento => setErroFinalizacao({ title: "Erro ao processar o pagamento", erros: erroPagamento })
    , erroVenda => setErroFinalizacao({ title: isOrcamento ? "Erro ao processar a orçamento" : "Erro ao processar a venda", erros: [erroVenda] }));

  function resetPg(pagamentos, liquido, limpar) {
    let recebido = liquido || totais.calcularLiquido(venda?.itensVenda, limpar ? INITIAL_VALORES_EXTRAS : valoresExtras);

    const pgtos = (pagamentos || []).filter(x => x.modalidadeId > 0);
    const valorPgtos = roundCustom(pgtos.reduce((a, b) => a + b.recebido, 0));

    if (valorPgtos < recebido)
      pgtos.push({ modalidadeId: null, recebido: roundCustom(recebido - valorPgtos) });

    setPg(pgtos);
  }

  useEffect(() => {
    if (visible) {

      let modelo;
      let tipoEmissaoNota = parametros['TipoEmissaoNotaVenda'];
      if (tipoEmissaoNota == "Cupom")
        modelo = "nfce";
      else if (tipoEmissaoNota == "Danfe")
        modelo = "nfe";

      setModeloNF(modelo);

      let valExtras = { descontoVendaPerc: 0, acrescimoPerc: 0, valorFrete: venda.valorFrete || 0, descontoVenda: venda.descontoVenda || 0, acrescimo: venda.acrescimo || 0 };

      let liquido = totais.calcularLiquido(venda?.itensVenda, valExtras);

      resetPg(venda?.pagamentos, liquido);
      setValoresExtras(valExtras);
      setLiquidoInicial(liquido + valExtras.descontoVenda - valExtras.acrescimo);
    }
    else
      setValoresExtras(INITIAL_VALORES_EXTRAS);

  }, [visible]);

  return <>
    <ModalPadrao
      visible={!!visible && !!venda.itensVenda.length}
      closable={false}
      title={isOrcamento ? "Finalizar Orçamento" : "Finalizar Venda"}
      width={window.innerWidth < 1000 ? window.innerWidth : 1000}
      footer={<>
        <BtnPadrao disabled={!isOrcamento && pg.find(x => x.modalidadeId == null || x.modalidadeId <= 0)} data-cy="btn-fin-modal" id="btn-finalizar" onClick={salvar}
          loading={salvando}
        >Finalizar</BtnPadrao>
        {processandoPagamentos ? <BtnCancelar loading={abortando} onClick={() => abortar()} showConfirm /> : <BtnSair disabled={salvando} onClick={onCancel} />}
      </>}>
      <LoadingContainerPadrao loading={salvando} loadingMsg={processandoPagamentos ? 'Processando pagamentos' : null}>
        {(!isOrcamento && props.hasCertificadoDigital) && <div style={{ textAlign: "center", marginBottom: 25 }}>
          <LabelPadrao noMargin>Forma de emissão</LabelPadrao>
          <Radio.Group value={modeloNF} onChange={v => setModeloNF(v.target.value)}>
            <Radio value="nfce">Cupom</Radio>
            <Radio style={{ margin: 0 }} value="nfe">Danfe</Radio>
          </Radio.Group>
        </div>}

        <Pagamento
          totais={totais}
          pg={pg}
          setPg={setPg}
          tipo={!isOrcamento ? "venda" : null}
          extra={<ValoresExtrasPagamento
            valoresExtras={valoresExtras}
            setValoresExtras={setValoresExtras}
            liquidoInicial={liquidoInicial}
            onBlur={() => resetPg()}
            limpar={() => resetPg(null, null, true)}
            acrescimoDisabled={(!parametros["PermiteVendaComAcrescimo"]) || pg.find(x => x.isSinal)}
            disabled={pg.find(x => x.isSinal)}
          />}
          clienteId={(venda.clienteId || [])[0]?.id || (venda.clienteId || [])[0]?.key}

          tabIndex={tabIndex}
          onValorMaximoEnter={() => setTimeout(() => document.getElementById("btn-finalizar").focus(), 100)}
        />

      </LoadingContainerPadrao>
    </ModalPadrao>

    <ErroModal title={erroFinalizacao?.title} visible={!!erroFinalizacao} onCancel={() => setErroFinalizacao(null)} >
      {erroFinalizacao?.erros?.map(x => <p key={x?.toString()} style={{ marginTop: 20, textAlign: "center" }}>{x?.toString()}</p>)}
    </ErroModal>

    <DanfeViewer visible={!!dadosDanfe} empresaPk={dadosDanfe?.empresaPk} chave={dadosDanfe?.chaveNfe} onCancel={() => setDadosDanfe(null)} />
    <ImpressaoVenda id={vendaImpressaoDados?.vendaId} tipo={vendaImpressaoDados?.tipo} onCancel={() => setVendaImpressaoDados(null)} />
    <ImpressaoVendaOpcional id={dadosImpressaoOpcional?.vendaImpressaoNaoObrigatoriaId} vias={dadosImpressaoOpcional?.vias} onOk={() => { setDadosImpressaoOpcional(null); onOk(true); }} onCancel={() => { setDadosImpressaoOpcional(null); onOk(true); }} />

    <ModalQrCode visible={!!linkQrCode} qrCode={linkQrCode} onCancel={abortar} loading={abortando} />
  </>;
}
const mapStateToProps = state => ({ dados: state.dados, hasCertificadoDigital: state.dados.hasCertificadoDigital, parametros: state.dados.parametros });

export default connect(mapStateToProps, { fetch, fetchLocalAgent })(Finalizar);